import React from 'react';
import Slider, { Settings as CarouselSettings } from 'react-slick';
import { VideoSliderType, PlayListType } from '../../../types';

const SliderItem: React.FC<PlayListType> = ({ title, image }) => {
  return (
    <div className="jw-single-video">
      <button>
        <div className="small-thumb">
          <img src={image} alt={title} />
        </div>
        <p className="video-thumb-title">{title}</p>
      </button>
    </div>
  );
};

const VideoSlider: React.FC<VideoSliderType> = ({ playList, onChange }) => {
  const settings: CarouselSettings = {
    // slidesToShow: 5,
    // slidesToScroll: 1,
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 3,
          
        },
      },
    ],
  };

  return (
    <Slider {...settings} afterChange={onChange}>
      {playList.map((item, i) => (
        <SliderItem {...item} key={i} />
      ))}
    </Slider>
  );
};

export default VideoSlider;
